const typography = {
  fontFamily: "'Helvetica Neue', sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: 1.25,
  },
  h2: {
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: 1.25,
  },
  h3: {
    fontWeight: 500,
    fontSize: "28px",
    lineHeight: 1.25,
  },
  h4: {
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: 1.25,
  },
  h5: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: 1.25,
  },
  h6: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: 1.25,
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: 1.25,
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: 1.5,
  },
  body1: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.5,
  },
  body2: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.5,
  },
  caption: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: 1.5,
  },
  button: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.71,
  },
};

export default typography;
